'use client';

import { forwardRef } from 'react';
import DallasSvgIcon from '@ui/Dallas/Icons/DallasSvgIcon';
import styles from './NavItem.module.scss';
import clsx from 'clsx';

export interface Props {
  icon: React.ReactElement<typeof DallasSvgIcon>;
  onClick: () => void;
  expanded?: boolean;
  'aria-label': string;
}

const NavButton = forwardRef<HTMLButtonElement, Props>(function NavButton(
  { onClick, icon, 'aria-label': ariaLabel, expanded }: Props,
  ref,
) {
  return (
    <button
      ref={ref}
      className={clsx(styles.root, styles.iconOnly)}
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      aria-expanded={expanded}
    >
      {icon}
    </button>
  );
});

export default NavButton;
